/* eslint max-classes-per-file: 0 */

import {
  Mark as Data,
  MarkCollection as Collection,
} from '@/typings/api/Marks'
import { ProceduresApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class ProceduresTransformerParams extends TransformerParams {

}

export class ProceduresAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new ProceduresTransformerParams();
}
